export const FEATURES = {
  ISHIKAWA: true,
  INVESTIGACAO_ACIDENTE: true,
  ESOCIAL: false,
  MATRIZ_GUT: false,
  CRONOGRAMA: false,
  TEMPLATE_WIZARD: false,
  EXPORT_PREMIUM: false,
} as const;

export type FeatureKey = keyof typeof FEATURES;

export function isFeatureEnabled(feature: FeatureKey): boolean {
  return FEATURES[feature] === true;
}
